import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import { Card, CardSection } from 'components/Card';
import Button from 'components/Button';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import Isvg from 'react-inlinesvg';
import { groupInquiriesByResponse } from './attendanceInquiryHelpers';
import SummarySection from './SummarySection';
import messages from './AttendanceInquiryModal.messages';
import './AttendanceInquiryModal.scss';

const { block, element } = bem('attendance-inquiry-summary');

const AttendanceInquirySummary = ({ inquiries, responses, onClose }) => {
  const groupedInquiries = groupInquiriesByResponse(inquiries, responses);

  return (
    <Card className={block()} flush>
      <CardSection className={element('header')}>
        <div className={element('close-button')}>
          <button
            type="button"
            onClick={onClose}
            name="close-button"
            aria-label="close-button"
            className={element('close-icon')}>
            <Isvg src={ICONS.cross} />
          </button>
        </div>
        <div className={element('success-header')}>
          <div className={element('success-icon')}>
            <Isvg src={ICONS.checkmarkInCircle} />
          </div>
          <div className={element('success-title')}>
            <Message message={messages.summaryTitle} />
          </div>
        </div>
      </CardSection>

      <CardSection className={element('content')}>
        <div className={element('scrollable-content')}>
          <SummarySection
            title={messages.summaryUserAllowedInTitle}
            description={messages.summaryUserAllowedInDescription}
            inquiries={groupedInquiries.userNotAllowed.allowed}
          />
          <SummarySection
            title={messages.summaryUserNotAllowedInTitle}
            description={messages.summaryUserNotAllowedInDescription}
            inquiries={groupedInquiries.userNotAllowed.notAllowed}
          />
          <SummarySection
            title={messages.summaryTookPlaceTitle}
            description={messages.summaryTookPlaceDescription}
            inquiries={groupedInquiries.classDidNotHappen.tookPlace}
          />
          <SummarySection
            title={messages.summaryDidNotOccurTitle}
            description={messages.summaryDidNotOccurDescription}
            inquiries={groupedInquiries.classDidNotHappen.didNotOccur}
          />
        </div>
      </CardSection>

      <CardSection className={element('actions')}>
        <Button styled="primary" onClick={onClose} className={element('close-button-full')}>
          <Message message={messages.buttonClose} />
        </Button>
      </CardSection>
    </Card>
  );
};

AttendanceInquirySummary.propTypes = {
  inquiries: PropTypes.arrayOf(
    PropTypes.shape({
      inquiryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      inquiryType: PropTypes.string.isRequired,
      userName: PropTypes.string,
      reservationName: PropTypes.string,
      reservationDatetime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    })
  ).isRequired,
  responses: PropTypes.instanceOf(Map).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AttendanceInquirySummary;
